import React, { useEffect, useState } from "react";
import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis } from "recharts";
import { PageTitle, StatCard } from "../../components/admin/AdminUi";
import { api } from "../../lib/api";
import { modelBadge } from "../../components/ModelSelect";

export default function AdminOverview() {
  const [s, setS] = useState(null);
  useEffect(() => { api.adminStats().then(setS).catch(() => {}); }, []);
  if (!s) return <div className="grid sm:grid-cols-4 gap-4">{[0, 1, 2, 3].map((i) => <div key={i} className="h-28 rounded-2xl shimmer border border-slate-200" />)}</div>;
  return (
    <div data-testid="admin-overview">
      <PageTitle title="Overview" desc="Platform health at a glance." />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard label="Users" value={s.users.total} sub={`${s.users.admins} admins · ${s.users.blocked} blocked`} testid="admin-stat-users" />
        <StatCard label="Projects" value={s.projects.total} sub={`${s.projects.published} live · ${s.projects.versions} versions`} testid="admin-stat-projects" />
        <StatCard label="AI builds" value={s.generations.total} sub={`${s.generations.last_24h} in 24h · ${s.generations.failed} failed`} testid="admin-stat-generations" />
        <StatCard label="Revenue" value={`₹${s.revenue.inr.toLocaleString("en-IN")}`} sub={`${s.revenue.credits_sold} credits · ${s.revenue.orders} orders`} accent="text-emerald-600" testid="admin-stat-revenue" />
      </div>
      <div className="mt-6 grid lg:grid-cols-3 gap-4">
        <div className="lg:col-span-2 rounded-2xl border border-slate-200 bg-white p-5" data-testid="admin-signups-chart">
          <h3 className="text-sm font-semibold text-slate-900 mb-4">Signups · last 14 days</h3>
          <div className="h-48">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={s.signups_14d}>
                <XAxis dataKey="date" tickFormatter={(d) => d.slice(5)} tick={{ fill: "#64748B", fontSize: 10 }} axisLine={false} tickLine={false} />
                <Tooltip cursor={{ fill: "#F1F5F9" }} contentStyle={{ background: "#fff", border: "1px solid #E2E8F0", borderRadius: 12, fontSize: 12 }} />
                <Bar dataKey="signups" fill="#10B981" radius={[4, 4, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div className="rounded-2xl border border-slate-200 bg-white p-5" data-testid="admin-model-usage">
          <h3 className="text-sm font-semibold text-slate-900 mb-4">Builds by model</h3>
          <div className="space-y-3">
            {s.generations.by_model.length === 0 && <p className="text-sm text-slate-500">No builds yet.</p>}
            {s.generations.by_model.map((m) => (
              <div key={m.model} className="flex items-center justify-between text-sm">
                <span className={`px-2 py-0.5 rounded border text-xs font-mono ${modelBadge(m.model)}`}>{m.model}</span>
                <span className="text-slate-600 font-mono">{m.count} · {m.credits}cr</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
